'use strict'

import angular from 'angular'

import css from './eye-catcher.styles.scss'
import template from './eye-catcher.template.pug'

export class EyeCatcherController {
  constructor(EyeCatcherService, $element, $scope, $rootScope, $timeout, $mdColors, $mdMedia) {
    'ngInject'
    Object.assign(this, { EyeCatcherService, $element, $scope, $rootScope, $timeout, $mdColors, $mdMedia })
    this.css = css // Workaround for ng-class, see https://github.com/nkbt/ng-modular/blob/gh-pages/src/hello/hello.html
  }

  $onInit() {
    const parent = angular.element(this.$element[0].parentNode)
    parent.on('scroll', (e) => this.scrollWatch(e))
  }

  $onDestroy() {
    const parent = angular.element(this.$element[0].parentNode)
    parent.off('scroll', (e) => this.scrollWatch(e))
  }

  /**
   * propagate parent scroll offset to eyecatcher service
   * @param e
   */
  scrollWatch(e) {
    this.EyeCatcherService.scrollOffset = e.target.scrollTop
    this.$rootScope.$digest()
  }

  /**
   * generate gradient css using material theme primary color
   * (cannot use object syntax, linear-gradient doesn't work with ng-style)
   * @returns {string}
   */
  gradientCss() {
    return `background: linear-gradient(to bottom, ${this.$mdColors.getThemeColor(
      'primary-500-0.3',
    )} 0%, ${this.$mdColors.getThemeColor('primary-500-0.5')} 100%);`
  }

  /**
   * generate wrapper css using material media queries
   * @returns {{background-image: string, height: string}}
   */
  wrapperCss() {
    let height = 240
    if (this.$mdMedia('xs')) height = 140
    if (this.$mdMedia('sm')) height = 160
    if (this.$mdMedia('md')) height = 186
    this.EyeCatcherService.eyecatcherHeight = height
    return {
      'background-image': `url(${this.src})`,
      height: `${height}px`,
    }
  }
}

export const umsEyeCatcher = {
  template: template({ css }),
  bindings: {
    src: '<?',
    title: '@?',
    subtitle: '@?',
    subsubtitle: '@?',
  },
  controller: EyeCatcherController,
}



// WEBPACK FOOTER //
// ./app/shared/components/eye-catcher/eye-catcher.component.js